webpackJsonp([163479603727795],{

/***/ 1813:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"IntervalConfig","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"amountCents","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"percent","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"statementNote","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"type","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"ENUM","name":"BillingGroupFeeType","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-interval-config-fc68bb620d3551698487.js